import { render, staticRenderFns } from "./benefitIntroduction.vue?vue&type=template&id=2927df45&"
import script from "./benefitIntroduction.vue?vue&type=script&lang=js&"
export * from "./benefitIntroduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports